"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.patchWorkspaceUserRequestDelayF = void 0;
var tslib_1 = require("tslib");
var patchWorkspaceUserSaga_1 = require("./../sagas/patch/patchWorkspaceUserSaga");
var effects_1 = require("redux-saga/effects");
var takeGaurd_1 = require("../../utilities/takeGaurd");
// Can be useful to prevent too many writes
var patchWorkspaceUserRequestDelayF = function () {
    var combinedWorkspaceUser, patchWorkspaceUserRequestAction, requestValues, item, params, workspaceId, userId, raceResult, anotherPatchAction, anotherPatchActionParams, isSameParams;
    return tslib_1.__generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!1) return [3 /*break*/, 8];
                combinedWorkspaceUser = {};
                return [4 /*yield*/, (0, takeGaurd_1.takeGaurd)('PATCH_WORKSPACE_USER_REQUEST_DELAY')];
            case 1:
                patchWorkspaceUserRequestAction = _a.sent();
                requestValues = patchWorkspaceUserRequestAction.requestValues;
                item = requestValues.item, params = requestValues.params;
                workspaceId = params.workspaceId, userId = params.userId;
                combinedWorkspaceUser = item;
                _a.label = 2;
            case 2:
                if (!1) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, effects_1.race)({
                        anotherPatch: (0, takeGaurd_1.takeGaurd)('PATCH_WORKSPACE_USER_REQUEST_DELAY'),
                        timeout: (0, effects_1.delay)(100),
                    })];
            case 3:
                raceResult = _a.sent();
                if (!raceResult.anotherPatch) return [3 /*break*/, 4];
                anotherPatchAction = raceResult.anotherPatch;
                anotherPatchActionParams = anotherPatchAction.requestValues.params;
                isSameParams = workspaceId === anotherPatchActionParams.workspaceId &&
                    userId === anotherPatchActionParams.userId;
                if (isSameParams) {
                    combinedWorkspaceUser = tslib_1.__assign(tslib_1.__assign({}, combinedWorkspaceUser), anotherPatchAction.requestValues.item);
                }
                return [3 /*break*/, 6];
            case 4:
                if (!(workspaceId && userId)) return [3 /*break*/, 6];
                return [4 /*yield*/, (0, effects_1.spawn)(patchWorkspaceUserSaga_1.patchWorkspaceUserSaga, {
                        workspaceUser: combinedWorkspaceUser,
                        workspaceId: workspaceId,
                        userId: userId,
                    })];
            case 5:
                _a.sent();
                return [3 /*break*/, 7];
            case 6: return [3 /*break*/, 2];
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
exports.patchWorkspaceUserRequestDelayF = patchWorkspaceUserRequestDelayF;
